import { Address as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type Address = {
  /**
   * Optional although the schema types it non-null: no committed selection asked for it before the
   * settlement's tax section, which echoes it back into `address_attributes` so Rails updates the
   * existing row instead of building a new `Address` on every save. A caller whose selection omits
   * it simply does not get one.
   */
  id?: number;
  city?: string;
  country?: string;
  postalCode?: string;
  state?: string;
  street1?: string;
  street2?: string;
};

export const fromGql = (item: GQLItem): Address =>
  take(item, 'id', 'city', 'country', 'postalCode', 'state', 'street1', 'street2');
